import { useMemo } from "react";
import { OrderLine } from "../../../../core/models/entities/Order";
import {
  GenericOrderLine,
  OrderLineHeaders,
  OrderLineHideColumns,
} from "./OrderLineData";
import { groupOrderLinesForDisplay } from "./groupOrderLinesForDisplay";
import { OrderLineGroupRow } from "./OrderLineGroupRow";

export interface OrderLineListProps {
  hideColumns?: OrderLineHideColumns;
  orderlines: OrderLine[];
  currency: string;
  showCustomerPrices?: boolean;
  readonly?: boolean;
}

export function OrderLineList({
  hideColumns,
  orderlines,
  currency,
  showCustomerPrices,
  readonly,
}: OrderLineListProps) {
  // TODO Hack to remove pricePerPiece column.
  //  If this is ultimately desired, remove the pricePerPiece column from all OrderLine components.
  if (!hideColumns) hideColumns = { unitPrice: true };
  else hideColumns.unitPrice = true;

  const filtered = useMemo(
    () =>
      orderlines.filter((line) => {
        if (
          line.type === "AdditionalFee" ||
          line.type === "Additional Fee" ||
          line.product.productType === "AdditionalFee"
        ) {
          const price = showCustomerPrices
            ? line.adjustedUnitPrice
            : line.unitPrice;
          return (price || 0) > 0;
        }
        return true;
      }),
    [orderlines, showCustomerPrices],
  );

  const groups = useMemo(() => groupOrderLinesForDisplay(filtered), [filtered]);

  return (
    <div className="max-h-[1000px] overflow-y-auto pr-2 order-line-list">
      <table
        className={
          "table-fixed border-collapse -sm:hidden empty-cells-hidden mx-auto w-full"
        }
      >
        <thead className={"uppercase"}>
          <OrderLineHeaders hide={hideColumns} />
        </thead>
        <tbody>
          {groups.map((group, i) => {
            if (group.variants.length > 1) {
              return (
                <OrderLineGroupRow
                  key={`group-${group.leader.id}`}
                  group={group}
                  hide={hideColumns}
                  currency={currency}
                  isFirstItem={i === 0}
                  showCustomerPrices={showCustomerPrices}
                  readonly={readonly}
                />
              );
            }
            return (
              <GenericOrderLine
                key={group.leader.id}
                orderline={group.leader}
                hide={hideColumns}
                currency={currency}
                isFirstItem={i === 0}
                showCustomerPrices={showCustomerPrices}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
